import {KM_OFFER_TEST_IDS} from "@pg-mono/test-ids";

import * as styles from "./GallerySwipeOnboardingHint.module.css";

const gallerySwipeOnboardingSrc = require("../../images/gallery-swipe-onboarding.svg");

interface IProps {
    visible: boolean;
}

export const GallerySwipeOnboardingHint = (props: IProps) => {
    const {visible} = props;
    if (!visible) return null;

    return (
        <div aria-hidden className={styles.hint} data-testid={KM_OFFER_TEST_IDS.GALLERY_SWIPE_ONBOARDING}>
            <img alt="" className={styles.animation} src={gallerySwipeOnboardingSrc} />
        </div>
    );
};
import {KM_OFFER_TEST_IDS} from "@pg-mono/test-ids";

import * as styles from "./GallerySwipeOnboardingHint.module.css";

const gallerySwipeOnboardingSrc = require("../../images/gallery-swipe-onboarding.svg");

interface IProps {
    visible: boolean;
}

export const GallerySwipeOnboardingHint = (props: IProps) => {
    const {visible} = props;
    if (!visible) return null;

    return (
        <div aria-hidden className={styles.hint} data-testid={KM_OFFER_TEST_IDS.GALLERY_SWIPE_ONBOARDING}>
            <img alt="" className={styles.animation} src={gallerySwipeOnboardingSrc} />
        </div>
    );
};
